import React, { useContext, useState } from 'react';
import Data from '../data';
import ModalModule from '../modal';
import UI from '../ui';
import RateAdvisorUtil from './RateAdvisorUtil';

const { ServiceType } = Data;
const { Modal, ModalContext, ModalButtonActionType } = ModalModule;
const { WrappedCheckbox } = UI;

/**
 * Requirement for this component can found be found:
 * https://stamps.atlassian.net/browse/WEBAPPS-26886
 */
const MediaMailSelectionModal = ({ data: { carrierServicesSelection, callback }, modalId }) => {
	const [dontShowChecked, setDontShowChecked] = useState(false);
	const { closeModal } = useContext(ModalContext);

	const onModalClose = () => {
		// exclude media mail selection
		const newCarrierServicesSelection = carrierServicesSelection.filter(
			service => service !== ServiceType.UspsMediaMail
		);

		closeModal(
			modalId,
			ModalButtonActionType.Ok,
			callback(dontShowChecked, newCarrierServicesSelection)
		);
	};

	const handleConfirmClick = () => {
		closeModal(
			modalId,
			ModalButtonActionType.Ok,
			callback(dontShowChecked, carrierServicesSelection)
		);
	};

	const secondaryButton = {
		type: ModalButtonActionType.Ok,
		onClick: handleConfirmClick,
		text: 'Enable Media Mail',
		dataqa: 'media-mail-selection-enable-button',
	};

	const primaryButton = {
		type: ModalButtonActionType.Cancel,
		text: "Don't Enable Media Mail",
		onClick: onModalClose,
		dataqa: 'media-mail-selection-dont-enable-button',
	};

	const onDontWarnMeAgainChecked = e => {
		const { checked } = e.target;

		setDontShowChecked(checked);

		// save the value in user preference
		RateAdvisorUtil.saveRateAdvisorUserPreference('showMediaMailSelectionModal', !checked);
	};

	return (
		<Modal
			modalId={modalId}
			className="common-rate-advisor media-mail-selection-modal"
			header="About Media Mail"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			onCloseButtonClick={onModalClose}
		>
			<div className="body">
				<p>
					Media Mail can only be used to ship certain items, including books, sound
					recordings, recorded video, printed music, and recorded computer-readable media
					such as CD's and DVD's.
				</p>
				<p>
					Only enable and use Media Mail if you're sure you're shipping an item that falls
					into these categories.
				</p>
				<div className="show-again">
					<WrappedCheckbox
						onChange={onDontWarnMeAgainChecked}
						checked={dontShowChecked}
						uiElementConfig={{
							dataqa: 'options-checkbox-dontShownAgain',
							name: 'dontShownAgain',
						}}
					>
						Don't Warn Me Again
					</WrappedCheckbox>
				</div>
			</div>
		</Modal>
	);
};

export default MediaMailSelectionModal;
